import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Input, Form, Card, CardHeader, CardBody } from '@heroui/react';
import { useAuth } from '../../context/AuthContext';

const Register = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    password: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (formData.password.length < 6) {
      setError('Password must be at least 6 characters long');
      return;
    }

    setIsLoading(true);

    try {
      const result = await register(formData.email, formData.password, formData.fullName);

      if (result.success) {
        navigate('/dashboard', { replace: true });
      } else {
        setError(result.error?.message || 'Registration failed. Please try again.');
      }
    } catch (err) {
      setError('An unexpected error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div 
      className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-blue-100 px-4"
      style={{ fontFamily: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif' }}
    >
      <Card className="max-w-md w-full" style={{ padding: '48px' }}>
        <CardHeader className="flex flex-col gap-3 px-0 pt-0 pb-6">
          <div className="flex justify-center w-full mb-2">
            <img 
              src="/taasa-logo.png" 
              alt="Taasa Logo" 
              className="h-28 w-auto"
            />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 text-center">Create Account</h1>
          <p className="text-gray-600 text-center">Welcome to world-class Road Safety and Emergency Services.</p>
        </CardHeader>
        
        <CardBody className="px-0 py-0">
          <Form onSubmit={handleSubmit} className="flex flex-col gap-4">
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
                {error}
              </div>
            )}

            <Input
              type="text"
              name="fullName"
              label="Full Name"
              labelPlacement="outside"
              placeholder="Enter your full name"
              value={formData.fullName}
              onChange={handleChange}
              isRequired
              size="lg"
            />

            <Input
              type="email"
              name="email"
              label="Email"
              labelPlacement="outside"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              isRequired
              size="lg"
            />

            <Input
              type="password"
              name="password"
              label="Password"
              labelPlacement="outside"
              placeholder="Create a password"
              value={formData.password}
              onChange={handleChange}
              isRequired
              size="lg"
            />

            <Input
              type="password"
              name="confirmPassword"
              label="Confirm Password"
              labelPlacement="outside"
              placeholder="Confirm your password"
              value={formData.confirmPassword}
              onChange={handleChange}
              isRequired
              size="lg"
            />

            <Button
              type="submit"
              color="primary"
              size="lg"
              className="w-full"
              isLoading={isLoading}
              disabled={isLoading}
            >
              Create Account
            </Button>

            <div className="text-center text-sm text-gray-600">
              Already have an account?{' '}
              <Link to="/login" className="text-blue-600 hover:text-blue-700 font-medium">
                Sign in
              </Link>
            </div>
          </Form>
        </CardBody>
      </Card>
    </div>
  );
};

export default Register;